import { render, staticRenderFns } from "./GrupoDeAcesso.vue?vue&type=template&id=67fd2450&scoped=true&lang=pug&"
import script from "./GrupoDeAcesso.vue?vue&type=script&lang=js&"
export * from "./GrupoDeAcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fd2450",
  null
  
)

export default component.exports